export const dashZipcode = (zip?: string | number | null) => {
  // Be very forgiving: if it's something we don't expect, give it back
  if (!zip) return zip;
  if (Number.isNaN(zip)) return zip;

  // If we have a 9-digit "ZIP+4 Code", assume it needs to be dashed
  if (String(zip).length === 9) {
    return `${String(zip).substring(0, 5)}-${String(zip).substring(5, 9)}`;
  }

  // If it's anything different, don't try to be fancy and just return it as entered
  return zip;
};
